import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MessagingService } from './services/messaging.service';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  message;
  constructor(private router: Router , private messagingService: MessagingService) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('firebase-messaging-sw.js').catch(() => {});
    }

    this.messagingService.requestPermission().catch(() => {});
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;

    this.bootstrapFromLanding();
  }

  private bootstrapFromLanding(): void {
    if (sessionStorage.getItem('landing_bootstrap') === 'done') {
      return;
    }
    const hash = window.location.hash;
    if (!hash || !hash.includes('token=')) {
      return;
    }
    const queryIndex = hash.indexOf('?');
    if (queryIndex === -1) {
      return;
    }
    const queryString = hash.slice(queryIndex + 1);
    const params = new URLSearchParams(queryString);
    const token = params.get('token');
    if (!token) {
      return;
    }
    for (const key of Array.from(params.keys())) {
      const value = params.get(key);
      if (value !== null && value !== undefined && value !== 'undefined' && value !== 'null') {
        if (key === 'accountId') {
          const accountIdNum = Number(value);
          if (accountIdNum > 0) {
            sessionStorage.setItem(key, accountIdNum.toString());
          }
        } else {
          sessionStorage.setItem(key, value);
        }
      }
    }
    const cleanHash = hash.split('?')[0];
    window.history.replaceState(null, '', cleanHash);
    sessionStorage.setItem('landing_bootstrap', 'done');
  }
}
